import React from "react";
import { Badge } from "react-bootstrap";
import { getPriorityVariant } from "./getPriorityVariant";

/**
 * Renders a Bootstrap Badge representing message priority.
 * @param {string} priority
 * @returns {JSX.Element}
 */
export function renderPriorityBadge(priority) {
  const variant = getPriorityVariant(priority);

  return (
    <Badge bg={variant} className="mx-0" style={{ fontSize: "0.75rem" }}>
      {priority?.toUpperCase() || "N/A"}
    </Badge>
  );
}